<template>
  <v-app-bar flat color="white" class="mx-12 pt-2 mb-8 mt-2">
    <v-col cols="6">
      <a href="/"
        ><v-img
          src="/images/Sigflo-PrimaryMark-Black.svg"
          height="61.66"
          width="153.11"
          contain
          :to="{ name: 'home' }"
        ></v-img
      ></a>
    </v-col>
    <v-col cols="6" class="text-right">
      <v-btn large text color="black" to="/venues" class="mr-1 button16"
        >Venues</v-btn
      >
      <!-- <v-btn large text color="black" class="mr-1 button16">About</v-btn> -->
      <v-btn
        large
        text
        color="black"
        class="mr-1 button16"
        :to="{ name: 'contact' }"
        >Contact</v-btn
      >
      <v-btn
        large
        outlined
        color="black"
        rounded
        dark
        class="text-capitalize mr-4"
        :href="configuratorLogin"
        >Login</v-btn
      >
      <v-btn
        color="black"
        large
        rounded
        dark
        class="mr-1"
        :href="configuratorHref"
        @click="handleBuildSystemClick"
        >Build Your System</v-btn
      >
    </v-col>
  </v-app-bar>
</template>

<script>
  export default {};
</script>

<style scoped></style>
